import React from "react";
import { Heading } from "@americanexpress/dls-react";
import "./PrivacyStyle.css";
import { useTranslation } from "react-i18next";
import Header from "../Header/Header";

const Privacy = () => {
  const { t, i18n } = useTranslation("common");
  i18n.changeLanguage(localStorage.getItem("lang"));

  return (
    <>
      <Header showlang={false} />
      <section id="privacy-page" className="mainBodyStatic">
        <div className="PrivacyPage">
          <div className="container">
            <div className="row">
              <div className="col-xs-12">
                <Heading
                  level={1}
                  headingStyle={"heading5"}
                  className="margin-1-b"
                >
                  {t("privacy.linksHeading")}
                </Heading>

                <hr />

                <div className="body-1 margin-1-b margin-1-t">
                  {t("privacy.text1")}
                </div>

                <div className="body-1 margin-1-b">{t("privacy.text2")}</div>
              </div>
            </div>

            <div className="row">
              <div className="col-xs-3">
                <div className="privacyLinks">
                  <ul>
                    <li>
                      <a href={t("privacy.australiaURL")} target="_blank">
                        {t("country.australia")}
                      </a>
                    </li>

                    <li>
                      <a href={t("privacy.hongkongURL")} target="_blank">
                        {t("country.hongkong")}
                      </a>
                    </li>

                    <li>
                      <a href={t("privacy.indiaURL")} target="_blank">
                        {t("country.india")}
                      </a>
                    </li>

                    <li>
                      <a href={t("privacy.japanURL")} target="_blank">
                        {t("country.japan")}
                      </a>
                    </li>

                    <li>
                      <a href={t("privacy.newzealandURL")} target="_blank">
                        {t("country.newzealand")}
                      </a>
                    </li>

                    <li>
                      <a href={t("privacy.norwayURL")} target="_blank">
                        {t("country.norway")}
                      </a>
                    </li>

                  </ul>
                </div>
              </div>

              <div className="col-xs-3">
                <div className="privacyLinks">
                  <ul>

                    <li>
                      <a href={t("privacy.singaporeURL")} target="_blank">
                        {t("country.singapore")}
                      </a>
                    </li>

                    <li>
                      <a href={t("privacy.swedenURL")} target="_blank">
                        {t("country.sweden")}
                      </a>
                    </li>

                    <li>
                      <a href={t("privacy.taiwanURL")} target="_blank">
                        {t("country.taiwan")}
                      </a>
                    </li>

                    <li>
                      <a href={t("privacy.thailandURL")} target="_blank">
                        {t("country.thailand")}
                      </a>
                    </li>

                    <li>
                      <a href={t("privacy.ukURL")} target="_blank">
                        {t("country.unitedKingdom")}
                      </a>
                    </li>

                    <li>
                      <a href={t("privacy.iecURL")} target="_blank">
                        {t("country.iec")}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default Privacy;
